import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteServiceCenter(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $id: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                deleteServiceCenter(id: $id)
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.DeleteServiceCenterMutation,
  undefined,
  graphql.schema.DeleteServiceCenterMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
